import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/admin/private-models",
)({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/private-models" });
	},
});
